import { Keys as o } from "../components/keyboard.js";
import { useEventListener as E } from "./use-event-listener.js";
import { useIsTopLayer as x } from "./use-is-top-layer.js";
function a(o$1, r = typeof document != "undefined" ? document.defaultView : null, t) {
  let n = x(o$1, "escape");
  E(r, "keydown", (e) => {
    n && (e.defaultPrevented || e.key === o.Escape && t(e));
  });
}
export {
  a as useEscape
};
